import * as tslib_1 from "tslib";
import { PreventableEvent } from './preventable-event';
/**
 * Fires when a tag is about to the removed. If you cancel the event, the removal is prevented.
 *
 * Arguments for the `remove` event:
 */
var RemoveTagEvent = /** @class */ (function (_super) {
    tslib_1.__extends(RemoveTagEvent, _super);
    /**
     * Constructs the event arguments for the `remove` event.
     * @param dataItem - The dataItem(s) that will be removed.
     */
    function RemoveTagEvent(dataItem) {
        var _this = _super.call(this) || this;
        _this.dataItem = dataItem;
        return _this;
    }
    return RemoveTagEvent;
}(PreventableEvent));
export { RemoveTagEvent };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dropdowns/dist/es/common/remove-tag-event.js
// module id = ../../../../@progress/kendo-angular-dropdowns/dist/es/common/remove-tag-event.js
// module chunks = vendor